export const API_ENDPOINT = "https://kyberna.cz";